import styled from 'styled-components'

export const Container = styled.main`
  align-items: center;
  background-color: black;
  color: #fff;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;

  .links-internos {
    padding: 2rem 0;
    align-items: center;
    font-size: 1.1rem;
    font-weight: bold;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;

    a {
      color: #fff;
      text-decoration: none;
      position: relative; /* Adicione esta linha */
    }

    a::after {
      content: '';
      position: relative; /* Alterado de absolute para relative */
      display: block; /* Adicionado para garantir que o elemento tenha uma dimensão */
      width: 0;
      height: 2px;
      background-color: #fff;
      transition: width 0.3s;
    }

    a:hover::after {
      width: 100%;
    }
  }

  @media only screen and (min-width: 1000px) {
    height: 100%;
  }
`
